import { render, staticRenderFns } from "./span-money.vue?vue&type=template&id=423dc25b&"
import script from "./span-money.vue?vue&type=script&lang=js&"
export * from "./span-money.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports